import { render, staticRenderFns } from "./EmailSettings.vue?vue&type=template&id=e639ecc6"
import script from "./EmailSettings.vue?vue&type=script&lang=js"
export * from "./EmailSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports